import { ref } from 'vue';

type EventCallback = (...args: any[]) => void;
const listeners = ref<Record<string, EventCallback[]>>({});

const on = (event: string, callback: EventCallback) => {
  if (!listeners.value[event]) {
    listeners.value[event] = [];
  }
  listeners.value[event].push(callback);
};

const off = (event: string, callback: EventCallback) => {
  if (!listeners.value[event]) {
    return;
  }
  listeners.value[event] = listeners.value[event].filter(
    (listener) => listener !== callback
  );
};

const emit = (event: string, ...args: any[]) => {
  if (!listeners.value[event]) {
    return;
  }
  listeners.value[event].forEach((listener) => listener(...args));
};

export const useEventBus = () => {
  return { on, off, emit };
};
